import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bh-seen',
  templateUrl: './bh-seen.component.html',
  styleUrls: ['./bh-seen.component.scss']
})
export class BhSeenComponent implements OnInit {
  @Input() text: string;
  @Input('type') set _type(_type) {
    if (_type) {
      this.interface.type = _type;
    }
  }

  interface = {
    type: 'default',
    list:[
      {
        "id": 68330,
        "title": "Forbes",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/Forbes_logo.svg",
          "width": 1390,
          "height": 363,
          "alt": "Forbes",
          "url": "https://argoprep.online/uploads/seen/Forbes_logo.svg"
        }
      },
      {
        "id": 11739,
        "title": "Yahoo",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/Yahoo_Finance_Logo_2019x200.png",
          "srcset": "",
          "width": 546,
          "height": 200,
          "alt": "Yahoo Finance",
          "url": "https://argoprep.online/uploads/seen/Yahoo_Finance_Logo_2019x200.png"
        }
      },
      {
        "id": 11737,
        "title": "NBC",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/200px-NBC_logo_2013.png",
          "srcset": "",
          "width": 200,
          "height": 180,
          "alt": "NBC",
          "url": "https://argoprep.online/uploads/seen/200px-NBC_logo_2013.png"
        }
      },
      {
        "id": 11735,
        "title": "Fox 5",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/fox-5200.png",
          "srcset": "",
          "width": 200,
          "height": 83,
          "alt": "fox 5",
          "url": "https://argoprep.online/uploads/seen/fox-5200.png"
        }
      },
      {
        "id": 11724,
        "title": "U.S. News",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/USnews-409.png",
          "srcset": "",
          "width": 409,
          "height": 100,
          "alt": "US News",
          "url": "https://argoprep.online/uploads/seen/USnews-409.png"
        }
      },
      {
        "id": 11721,
        "title": "American Express",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/american-express200.png",
          "srcset": "",
          "width": 400,
          "height": 200,
          "alt": "American Express",
          "url": "https://argoprep.online/uploads/seen/american-express200.png"
        }
      },
      {
        "id": 11709,
        "title": "Business insider",
        "thumbnail": {
          "src": "https://argoprep.online/uploads/seen/business-insider-1.png",
          "srcset": "",
          "width": 1024,
          "height": 318,
          "alt": "business insider",
          "url": "https://argoprep.online/uploads/seen/business-insider-1.png"
        }
      }
    ]
  }

  constructor() { }

  ngOnInit(): void {
  }

}
